import Swiper from "swiper";

const imageSlider = document.querySelector(".half-image-slider");
if (imageSlider) {
  const swiper = new Swiper(imageSlider, {
    spaceBetween: 30,
    centeredSlides: true,
    loop: true,
    effect: "fade",
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
     pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
}
